import { useState } from "react";
import { toast } from "@/hooks/useToast";
import { formatCompletionDate, normalizeDisplayName } from "./certificateData";
import { downloadCertificate } from "./downloadCertificate";

interface CertificateDownloadLinkProps {
  attendeeName: string;
  courseName: string;
  sessionDates: string;
}

export function CertificateDownloadLink({
  attendeeName,
  courseName,
  sessionDates,
}: CertificateDownloadLinkProps) {
  const [isPreparing, setIsPreparing] = useState(false);

  const handleClick = () => {
    setIsPreparing(true);

    downloadCertificate({
      attendeeName: normalizeDisplayName(attendeeName),
      courseName: normalizeDisplayName(courseName),
      completionDate: formatCompletionDate(sessionDates),
    })
      .catch(() => {
        toast({
          title: "Error",
          description:
            "We could not generate that certificate. Please try again.",
          variant: "destructive",
        });
      })
      .finally(() => {
        setIsPreparing(false);
      });
  };

  return (
    <button
      className="text-gray-500 transition-colors hover:text-gray-900 disabled:cursor-not-allowed disabled:text-gray-400 dark:text-gray-400 dark:hover:text-white dark:disabled:text-slate-500"
      disabled={isPreparing}
      onClick={handleClick}
      type="button"
    >
      {isPreparing ? "Preparing..." : "Download"}
    </button>
  );
}
